import {Style, Fill, Stroke, Icon, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class FixLayer extends GeoJsonLayer {
    icon_cache = {};

    constructor( map, settings = {}){
        settings["name"] = 'fix';
        settings["api_endpt"] = "FixSiteJSON.php";
        if( settings['labels'] == undefined ) settings["labels"] = false;
        if( settings['scale'] == undefined ) settings["scale"] = 1;
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        return url.toString();
    }

    getIconSize( feature ){
        return this.settings['scale']*20;
    }

    getIcon( feature ){
        let params = "";
        params = params + "code=FIXN";
        return this.icon_path+'/wxicon.php?'+params;
    }

    getLabel( feature ){
        let str = "";
        if( this.settings['labels'] == true ){
            str = this.property(feature,'id');
        }
        return str;
    }

    getPopupText( feature ){
        let text = this.popupTitle( "FIX", this.property(feature,'id') );
        text += this.popupData( "Type", this.property(feature,'type'));
        text += this.popupEnd();
        return text;
    }

    getStyle(feature, resolution ){
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[feature.getId()] )
            icon = this.icon_cache[feature.getId()];
        else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }
        let style = new Style({
                "image": icon,
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": "black"
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 }),
                        "offsetX": -20,
                        "offsetY": 12
                        })
                });
        return style;
    }

}
